import React, { Component } from "react";
import Joi from "joi-browser";
import DefaultInput from "./defaultInput";
import Select from "./select";
import LanguagePtBr from "../language";
import DatePickerInput from "./datePickerInput";
import TypeaheadSelect from "./typeaheadSelect";

class DefaultForm<T> extends Component<T, any, any> {
  [x: string]: any;
  state = {
    data: {},
    errors: {},
    submitting: false
  };

  validate = (): object => {
    let options = {};

    options = {
      abortEarly: false,
      language: LanguagePtBr.errors,
    };
    const { error } = Joi.validate(this.state.data, this.schema, options);
    const filtered = this.onValidate ? this.onValidate(error) : error;

    if (!filtered) return null;
    const errors = {};
    for (let item of filtered.details) {
      errors[item.path[0]] = item.message;
    }
    return errors;
  };

  validateProperty = ({ name, value }) => {
    let options = {};

    options = {
      abortEarly: false,
      language: LanguagePtBr.errors,
    };
    const obj = { [name]: value };
    const schema = { [name]: this.schema[name] };
    const { error } = Joi.validate(obj, schema, options);
    const filtered = this.onValidateProperty
      ? this.onValidateProperty({ error, name, value })
      : error;

    return filtered ? filtered.details[0].message : null;
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const data = { ...this.state.data };
    Object.keys(data).map(
      (k) => typeof data[k] === "string" && (data[k] = data[k].trim())
    );

    this.setState({ data }, () => {
      const errors = this.validate();

      this.setState({ errors: errors || {} });
      if (errors) return;

      this.setState({ submitting: true });

      // @ts-ignore
      this.doSubmit();
    });
  };

  calculateTotalValue() {
    const data = { ...this.state.data };

    const nInstallments = +data["quantidadeParcelas"] || 1;

    let installmentValue;

    if (typeof data["valorParcela"] === "string") {
      installmentValue =
        +data["valorParcela"].toString().replace(/[^0-9]/g, "") / 100;
    } else {
      installmentValue = data["valorParcela"];
    }

    const total = nInstallments * installmentValue;
    data["valorBruto"] = total;
    this.setState({ data });
  }

  handleChange = ({ currentTarget: input }, afterChange = null) => {
    const errors = { ...this.state.errors };
    const errorMessage = this.validateProperty(input);
    if (errorMessage) errors[input.name] = errorMessage;
    else delete errors[input.name];
    const data = { ...this.state.data };

    if (input.files) {
      data["files"] = input.files[0];
    }

    data[input.name] = input.value;

    console.log("-----", input.name, afterChange);
    if (afterChange) {
      this.setState({ data, errors }, () => afterChange());
    } else {
      this.setState({ data, errors }, () => {
        if (input.name === "valorParcela") {
          this.calculateTotalValue();
        }
      });
    }
  };

  handleChangeMask = (input, value) => {
    const errors = { ...this.state.errors };
    const errorMessage = this.validateProperty({ name: input.name, value });
    if (errorMessage) errors[input.name] = errorMessage;
    else delete errors[input.name];
    const data = { ...this.state.data };

    if (input.files) {
      data["files"] = input.files[0];
    }

    data[input.name] = value;
    data[input.name + "Masked"] = input.value;
    this.setState({ data, errors }, () => {
      if (input.name === "quantidadeParcelas") {
        this.calculateTotalValue();
      }
    });
  };

  handleChangeDate = (name, date) => {
    const errors = { ...this.state.errors };
    const errorMessage = this.validateProperty({ name, value: date });
    if (errorMessage) errors[name] = errorMessage;
    else delete errors[name];
    const data = { ...this.state.data };
    data[name] = date;
    this.setState({ data, errors });
  };

  handleChangeTypeahead = (name, valor) => {
    const errors = { ...this.state.errors };
    const errorMessage = this.validateProperty({ name, value: valor });
    if (errorMessage) errors[name] = errorMessage;
    else delete errors[name];
    const data = { ...this.state.data };

    data[name] = valor;
    this.setState({ data, errors });
  };

  renderButton(label, className = "", onClick = null, isForm = false) {
    const { submitting } = this.state;
    const hasErrors = Object.keys(this.validate() || {}).length > 0;
    console.log("----",{ validate: this.validate(), hasErrors });
    return submitting ? (
      <button disabled className={className || "btn btn-primary"}>
        <i className="fa fa-spinner fa-spin" /> {"Carregando"}
      </button>
    ) : !onClick ? (
      <button
        disabled={hasErrors}
        className={className || "btn btn-primary"}
      >
        {label}
      </button>
    ) : onClick && isForm ? (
      <button
        onClick={onClick}
        disabled={hasErrors}
        className={className || "btn btn-primary"}
      >
        {label}
      </button>
    ) : (
      <button onClick={onClick} className={className || "btn btn-primary"}>
        {label}
      </button>
    );
  }

  renderInput(
    name,  //1
    label, //2
    type = "text",//3
    autoComplete = false, //4
    disabled = false, //5
    bold = false, //6
    required = false, //7
    placeholder = "", //8
    mask = null, //9
    afterChange = null, //10
    currency = false, //11
    ...rest
  ) {
    const { data, errors } = this.state;

    return (
      <DefaultInput
        type={type}
        name={name}
        value={data[name] || ""}
        label={label}
        onChange={
          mask
            ? this.handleChangeMask
            : (input) => this.handleChange(input, afterChange)
        }
        error={errors[name]}
        autoComplete={autoComplete ? null : "off"}
        disabled={disabled}
        bold={bold.toString()}
        required={required}
        placeholder={placeholder}
        mask={mask}
        currency={currency ? currency.toString() : undefined}
        {...rest[0]}
      />
    );
  }

  renderDatePickerMonthInput(
    name,
    label,
    autoComplete = false,
    disabled = false
  ) {
    const { data, errors } = this.state;

    return (
      <DatePickerInput
        name={name}
        label={label}
        selected={data[name]}
        dateFormat="MMMM/yyyy"
        showMonthYearPicker
        onChange={(date) => this.handleChangeDate(name, date)}
        error={errors[name]}
        autoComplete={autoComplete ? null : "off"}
        disabled={disabled}
      />
    );
  }

  renderDatePickerInput(
    name,
    label,
    autoComplete = false,
    disabled = false,
    bold = false,
    required = false
  ) {
    const { data, errors } = this.state;

    return (
      <DatePickerInput
        name={name}
        label={label}
        selected={data[name]}
        dateFormat="dd/MM/yyyy"
        onChange={(date) => this.handleChangeDate(name, date)}
        error={errors[name]}
        autoComplete={autoComplete ? null : "off"}
        disabled={disabled}
        bold={bold}
        required={required}
      />
    );
  }

  renderSelect(
    name,
    items,
    label,
    text = null,
    value = null,
    noEmpty = false,
    disabled = false,
    bold = false,
    required = false,
    placeholder = "",
    afterChange = null
  ) {
    const { data, errors } = this.state;
    if (text && value) {
      return (
        <Select
          name={name}
          value={data[name] || ""}
          items={items}
          label={label}
          onChange={(input) => this.handleChange(input, afterChange)}
          error={errors[name]}
          textProperty={text}
          valueProperty={value}
          noEmpty={noEmpty}
          disabled={disabled}
          bold={bold}
          required={required}
          placeholder={placeholder}
        />
      );
    }
    return (
      <Select
        name={name}
        value={data[name] || ""}
        items={items}
        label={label}
        onChange={this.handleChange}
        error={errors[name]}
        noEmpty={noEmpty}
        disabled={disabled}
        bold={bold}
      />
    );
  }

  renderTypeaheadSelect(
    name,
    items,
    label,
    disabled = false,
    text = null,
    value = null,
    bold = false,
    required = false
  ) {
    const { data, errors } = this.state;
    return (
      <TypeaheadSelect
        name={name}
        items={items}
        label={label}
        selected={data[name]}
        onChange={(selected) => this.handleChangeTypeahead(name, selected)}
        error={errors[name]}
        disabled={disabled}
        bold={bold}
        required={required}
      />
    );
  }
}

export default DefaultForm;
